import { render, staticRenderFns } from "./ReportHumanCapitalAward.vue?vue&type=template&id=3a171d3e&"
import script from "./ReportHumanCapitalAward.vue?vue&type=script&lang=js&"
export * from "./ReportHumanCapitalAward.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports